import React from "react";
import "./style.css";
import { Navigation, Scrollbar, Autoplay } from "swiper/modules";
import { Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const CardSlider = (props) => {
  return (
    <Swiper
      className="relative"
      modules={[Navigation, Scrollbar, Autoplay]}
      spaceBetween={20}
      breakpoints={{
        0: { slidesPerView: 1 }, // Start at 0 for smallest screens
        500: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1440: { slidesPerView: 3 },
      }}
      // slidesPerView={"auto"}
      loop={true}
      autoplay={true}
      observeParents
      observer
      onSwiper={props.onSwiper}
      scrollbar={{ draggable: true }}
      onChangeDirection={props.onChangeDirection}
      onReachEnd={props.onReachEnd}
      onReachBeginning={props.onReachBeginning}
      onSlideChange={props.onSlideChange}>
      {props.children}
          
    </Swiper>
  );
};

export default CardSlider;
